module.exports = __webpack_public_path__ + "img/file-05.f45a1aad.svg";